export default __webpack_public_path__ + "static/media/thumb-Multi-GNSS-Module-4.2c834fab.png";